import { PopupMessageButtonClasses } from "sb-resp-ui";
export const defaultActionsClasses = {
    close: {
        classes: PopupMessageButtonClasses.negative
    },
    accept: {
        classes: PopupMessageButtonClasses.positive
    },
    confirm: {
        classes: PopupMessageButtonClasses.positive
    },
    cancel: {
        classes: PopupMessageButtonClasses.default
    },
    default: {
        classes: PopupMessageButtonClasses.default
    }
};
//# sourceMappingURL=defaultActionClasses.js.map